<template>
  <div class='container'>

    <el-row style="margin-bottom:40px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster-report' }">汇报</el-breadcrumb-item>
        <el-breadcrumb-item >列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
   
    <div class="report_main">
      <el-form :inline="true" :model="searchFormData" class="demo-form-inline">
        <el-form-item label="项目选择" prop="project_id">
          <el-select
              v-model="searchFormData.project_id" placeholder="全部"
                clearable
                filterable
                @change="selectProject"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="职位选择">
          <el-select
              v-model="searchFormData.job_id" placeholder="全部"
                clearable
                filterable
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>
        </el-form-item>

        <el-form-item label="类型">
          <el-select v-model="searchFormData.type" placeholder="请选择" clearable>
            <el-option label="日报" value="1" key="1"></el-option>
            <el-option label="周报" value="2" key="2"></el-option>
            <el-option label="月报" value="3" key="3"></el-option>

          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>


        <el-table
          ref="table"
          v-loading="searchLoading"
          :data="pageProps.records"
          element-loading-text="正在查询"
          fit
          stripe
          highlight-current-row
        >

          <el-table-column align="center" label="昵称"  prop="nickname"/>
          <el-table-column align="center" label="姓名"  prop="name"/>
          <el-table-column align="center"  label="手机号码" prop="mobile" />
          <el-table-column align="center"  label="性别" prop="sex" >

            <template slot-scope="{row}">
                <span v-if="row.sex==1">男</span>
                <span v-if="row.sex==2">女</span>
                <span v-if="row.sex==0">不公开</span>
              </template>
          </el-table-column>
          <el-table-column align="center"  label="地址" prop="address" />
          <el-table-column align="center"  label="操作">

            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="detailInfo(scope.row.id)"
              >详情</el-button>

            </template>

          </el-table-column>

         
      </el-table>
      <div style="text-align:center;padding:20px">
        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageProps.total"
          :page-size="pageProps.pageSize"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="pageProps.pageNum"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      
    </div>
    <detail-dialog ref="detailDialog" @refresh="fetchData"></detail-dialog>

  </div>
    
</template>

<script>
import detailDialog from "@/views/director/workmaster/application/report/detail-dialog.vue";

import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";
import { reportList } from "@/api/director/workmaster/index";



  export default {
    name: "director-workmaster-clock-month",
    components: { detailDialog},

    data() {
      return {
       
        searchLoading: false,
        pageProps: {
          records:[],
          total: 0,
          pageSize: 10,
          pageNum: 1
        },

        searchFormData:{
          project_id:"",
          job_id:"",
          type:"",
          page:0,
          limit:0
        },
        projectDataList:[],
        jobDataList:[],

      }
    },

    mounted() {
      if(this.$route.query.type){
        this.searchFormData.type = this.$route.query.type;
      }
      this.fetchData();
     this.initProjectList();
     this.initJobList();
    },


    methods: {

        //项目列表
    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
      });
    },
    

    //职位列表
    initJobList(){
      var that = this;
      jobList({project_id:that.searchFormData.project_id}).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },

        
   selectProject(e){
      var that=this;
      console.log(e)
      this.searchFormData.project_id=e;
      that.searchFormData.job_id="";
      this.initJobList();

    },


      search(){
        this.fetchData();
      },

      fetchData(){
        var that = this;
        that.searchFormData.page=that.pageProps.pageNum;
        that.searchFormData.limit=that.pageProps.pageSize;

        reportList(that.searchFormData).then((response) => {
          console.log("approval_list",response);
          if(response.code==200){
            that.pageProps.records = response.data.data;
            that.pageProps.total = response.data.total;
          }else{
            that.$message.error(response.msg?response.msg:"请求错误");
          }
         
        });
      },

       // 当前页变更
      handleCurrentChange(num) {
        this.pageProps.pageNum = num
        this.fetchData()
      },


      // 每页显示页面数变更
      handleSizeChange(size) {
        this.pageProps.pageSize = size
        this.fetchData()
      },

      detailInfo(report_id){
      this.$refs.detailDialog.init(report_id);
    }
      
      
    }
  }
</script>


<style lang="scss" scoped>
.report_nav {
  // height: 72px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 19px;
  ul {
    display: flex;

    li {
      position: relative;
      a {
        padding: 0 24px;
        display: block;
        font-size: 16px;
        &.router-link-active {
          //background-color: #4c71db;
          border-bottom: 1px solid #4c71db;
          color:#4c71db ;
          font-weight: bold;
          //color: #fff;
        }
      }
      aside {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        background-color: #ff4e4e;
        border-radius: 10px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }
    }

   
  }
}
.report_main {
  border-radius: 6px;
  
}
</style>